module.exports = __webpack_public_path__ + "img/52a192b1-bea5-4b48-879f-107f009b666f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/52a192b1-bea5-4b48-879f-107f009b666f.svg
// module id = 158
// module chunks = 245 246